/**
 * DOM manipulation utilities
 */
export function globalBlur() {
    var _a;
    const activeElement = document.activeElement;
    (_a = activeElement === null || activeElement === void 0 ? void 0 : activeElement.blur) === null || _a === void 0 ? void 0 : _a.call(activeElement);
}
export function globalFocus(id, delayMs = 10) {
    if (!id) {
        globalBlur();
        return;
    }
    const el = typeof id == 'string' ? document.getElementById(id) : id;
    el === null || el === void 0 ? void 0 : el.focus();
    setTimeout(() => el === null || el === void 0 ? void 0 : el.focus(), delayMs);
}
export function globalFocusQuery(selector, delayMs = 10) {
    const el = document.querySelector(selector);
    el === null || el === void 0 ? void 0 : el.focus();
    setTimeout(() => el === null || el === void 0 ? void 0 : el.focus(), delayMs);
}
